import Checkbox from 'apps/Onboarding/components/Checkbox'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const InternationalDocumentCheck = ({
  checked,
  onChange
}: {
  checked: boolean
  onChange: React.Dispatch<React.SetStateAction<boolean>>
}): React.ReactElement => {
  const { t } = useTranslation()
  const internationalDocumentCheckTitle = t('wizard.documents.iHavePassportOrINM')

  const handleClick = (): void => onChange(!checked)

  return <Checkbox text={internationalDocumentCheckTitle} checked={checked} handleChange={handleClick} />
}
